/**
 * A reconcile pass that hangs off no turn — superseded, failed, or one whose
 * committed turn fell outside the transcript window.
 *
 * It gets a row of its own rather than being dropped. A screen whose stated
 * purpose is "what did the reasoner decide" that silently omits every decision
 * which did not survive would be worst exactly where it matters: an operator
 * looking at a pebble where nothing happened would see nothing happening.
 */
import { Badge, type Tone } from './ui';
import VerdictCard from './VerdictCard';
import type { PassRow as PassRowModel } from './trace';

const REASON: Record<string, { text: string; tone: Tone }> = {
  failed: { text: 'this pass failed and committed nothing', tone: 'red' },
  superseded: { text: 'superseded by a later pass', tone: 'amber' },
  no_commit: { text: 'committed no turn (greeting or no-op pass)', tone: 'gray' },
  committed: { text: 'committed a turn outside this transcript window', tone: 'blue' },
};

export default function PassRow({ row }: { row: PassRowModel }) {
  const reason = row.offWindow ? REASON.committed : (REASON[row.verdict.outcome] ?? REASON.no_commit);
  return (
    <div className="flex justify-center" data-testid="pass-row">
      <div className="w-full md:w-11/12">
        <div className="flex items-center gap-2 flex-wrap text-xs mb-1">
          <Badge tone={reason.tone}>reconcile pass</Badge>
          <span className="text-gray-600">{reason.text}</span>
          {row.undated && <span className="text-gray-500">no created_at — placed last</span>}
        </div>
        <VerdictCard verdict={row.verdict} />
      </div>
    </div>
  );
}
